import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/use-online-status";

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 bg-amber-600/95 backdrop-blur-sm px-4 py-2 text-sm font-medium text-white shadow-lg">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>You&apos;re offline — showing cached data</span>
    </div>
  );
}
